module.exports = __webpack_public_path__ + "img/can.fd708eab.jpg";